import type { JsxgraphThemeService } from '../jsxgraph-theme.service';
import type { LineStyleOverrides } from '../jsxgraph.model';

export interface LineStyleOptions {
  themeService: JsxgraphThemeService;
  overrides?: LineStyleOverrides;
}

/**
 * Get line style options from theme with optional overrides.
 */
export function getLineStyle(opts: LineStyleOptions): Record<string, unknown> {
  const { themeService, overrides } = opts;

  const strokeColor =
    overrides?.strokeColor ||
    (overrides?.colorName ? themeService.getColor(overrides.colorName) : themeService.getColor('sky'));

  return {
    strokeColor,
    strokeWidth: overrides?.strokeWidth ?? 2,
    dash: overrides?.dash ?? 0,
  };
}
